import { MessagesSquare, Ruler, ShieldCheck, Building2, Home as HomeIcon, LifeBuoy } from "lucide-react";
import { PageHero, CTASection } from "@/components/sections";
import { Stagger, StaggerItem } from "@/components/primitives";
import { SERVICES } from "@/lib/site";

const ICONS = [MessagesSquare, Ruler, ShieldCheck, Building2, HomeIcon, LifeBuoy];

const Servizi = () => (
  <>
    <PageHero
      eyebrow="Servizi"
      title={"Ti seguiamo\nin ogni passaggio."}
      subtitle="Non vendiamo solo prodotti: offriamo un servizio completo di consulenza, misurazione e assistenza continuativa."
      testid="servizi-hero"
    />

    <section className="py-20 lg:py-28 bg-white" data-testid="servizi-grid">
      <div className="container-x">
        <Stagger className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <StaggerItem key={s.title}>
                <div className="card-clean h-full p-8" data-testid={`servizio-${i}`}>
                  <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-green/10 text-green">
                    <Icon size={24} />
                  </span>
                  <h3 className="mt-6 font-serif text-2xl font-bold text-navy">{s.title}</h3>
                  <p className="mt-3 text-muted-foreground leading-relaxed">{s.desc}</p>
                </div>
              </StaggerItem>
            );
          })}
        </Stagger>
      </div>
    </section>

    <CTASection />
  </>
);

export default Servizi;
